import React from 'react';
import { ChatBubble } from './chat-bubble';
import { ChatRecommendationContent } from './chat-recommendation-content';
import { ChatImageContent } from './chat-image-content';
import { ChatDocumentContent } from './chat-document-content';
import { ChatAudioContent } from './chat-audio-content';
import { isImageFromMime, isAudioFromMime, safeJsonParse } from '../utils/helpers';

const ChatMessage = React.memo(
  ({
    senderName,
    item,
    isReceived,
    onPressMessage,
    onPressImage,
    onPressRecommendation,
    onPressDocument,
    onPressAudio,
    audioLoading,
    recommendationData,
    recommendationLoading,
    documentLoading
  }) => {
    // file_metadata is stored from the frontend as stringify json, it must be parsed to be used again
    const fileMetaData = safeJsonParse(item.file_metadata);

    // Figure out what type of message this is
    const isImage = item.uploaded_file_signed_url && isImageFromMime(fileMetaData?.file_type);
    const isAudio = item.uploaded_file_signed_url && isAudioFromMime(fileMetaData?.file_type);
    const isDocument = item.uploaded_file_signed_url && !isImage && !isAudio;
    const isRecommendation = item.recommendation_id;

    return (
      <ChatBubble
        senderName={senderName}
        hidden={item.hidden}
        message={item.message}
        timestamp={item.timestamp}
        markAsRead={item.admin_timestamp_read}
        isReceived={isReceived}
        isEdited={item.is_edited}
        onPress={onPressMessage}
      >
        {isRecommendation ? (
          <ChatRecommendationContent
            recommendation={recommendationData}
            loading={recommendationLoading}
            onPress={onPressRecommendation}
          />
        ) : isImage ? (
          <ChatImageContent
            style={{ marginBottom: item.message ? 10 : 0 }}
            src={item.uploaded_file_signed_url}
            onPress={onPressImage}
          />
        ) : isAudio ? (
          <ChatAudioContent
            src={item.uploaded_file_signed_url}
            onPlay={onPressAudio}
            loading={audioLoading}
          />
        ) : isDocument ? (
          <ChatDocumentContent
            style={{ marginBottom: item.message ? 10 : 0 }}
            src={item.uploaded_file_signed_url}
            fileName={fileMetaData.file_name}
            fileSize={fileMetaData.file_size}
            onPress={onPressDocument}
            loading={documentLoading}
          />
        ) : null}
      </ChatBubble>
    );
  }
);

export { ChatMessage };
